// Used for websocket to identify unique tab for websocket (more stable than session)

let fallbackTabId = null;

const sessionStorageOrNull = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage;
  } catch (_error) {
    return null;
  }
};

const createTabId = () => {
  try {
    if (typeof window !== "undefined" && window.crypto?.randomUUID) {
      return window.crypto.randomUUID();
    }
  } catch (_error) {
    // Fall through to Math.random when crypto is unavailable in restricted webviews.
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export function getTabId() {
  const k = "incite_tab_id";
  const storage = sessionStorageOrNull();

  if (!storage) {
    if (!fallbackTabId) fallbackTabId = createTabId();
    return fallbackTabId;
  }

  try {
    let id = storage.getItem(k);
    if (!id) {
      id = createTabId();
      storage.setItem(k, id);
    }
    return id;
  } catch (_error) {
    if (!fallbackTabId) fallbackTabId = createTabId();
    return fallbackTabId;
  }
}
